import { Vue, Component, Ref } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import ConceptsModalBasicForm from '@/modules/configurationModule/detail/accounting/non-billable/concepts/components/concepts-modal-basic-form/concepts-modal-basic-form.vue'
import ConfigurationSidepanel from '@/modules/configurationModule/detail/ConfigurationSidepanel.vue'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

@Component({
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        GridDisplayOptions,
        ConceptsModalBasicForm,
        ConfigurationSidepanel
    }
})
export default class ConceptsGrid extends Vue {
    @Ref() readonly conceptsModalBasicForm!: any

    private actionTitle !: string
    private selectedRows !: Array<object>
    private rowData!: Array<object>
    private columnDefs!: Array<object>
    private gridApi !: any
    private showSidepanel !: boolean
    private sidepanelTitle !: string
    private selectedUnitRates !: Array<object>

    constructor() {
        super()
        this.actionTitle = ''
        this.selectedRows = []
        this.columnDefs = [
            { type: 'customCheckbox' },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.concept', 1),
                colId: 'concept',
                field: 'concept',
                minWidth: 250,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.code'),
                colId: 'code',
                field: 'code',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.description'),
                colId: 'description',
                field: 'description',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.snomedCTCode'),
                colId: 'snomedCTCode',
                field: 'snomedCTCode',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.unit', 1),
                colId: 'unit',
                field: 'unit',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.entityType'),
                colId: 'entityType',
                field: 'entityType',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.group'),
                colId: 'group',
                field: 'group',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.groupCode'),
                colId: 'groupCode',
                field: 'groupCode',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'checkIconRenderer',
                headerName: i18n.t('configuration.grid.active'),
                colId: 'active',
                field: 'active',
                minWidth: 80,
                suppressSizeToFit: true
            }
        ]
        this.rowData = [
            {
                concept: 'Post-transplante: biopsia',
                code: '001',
                group: 'GRUPO3',
                groupCode: 'GR003',
                active: true
            },
            {
                concept: 'Biopsia',
                code: '002',
                group: 'GRUPO3',
                groupCode: 'GR003',
                active: true
            },
            {
                concept: 'Citología',
                code: '003',
                group: 'GRUPO4',
                groupCode: 'GR004',
                active: true
            }
        ]
        this.gridApi = null
        this.showSidepanel = false
        this.sidepanelTitle = ''
    }

    get gridOptions(): GridOptions {
        return {
            sideBar: gridSideBarConfig,
            rowModelType: AgGridRowModelType.CLIENT_SIDE,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: params => {
                this.onGridReady(params)
            },
            onRowSelected: params => {
                this.onRowSelected()
            },
            onRowClicked: params => {
                this.onRowClickedSidepanel()
                this.sidepanelTitle = params?.node.data.concept
            }
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            return [
                {
                    name: this.$t('configuration.actions.update').toString()
                },
                {
                    name: this.$t('configuration.actions.delete').toString()
                },
                {
                    name: this.$t('configuration.actions.activate').toString()
                },
                {
                    name: this.$t('configuration.actions.deactivate').toString()
                }
            ]
        }
    }

    onRowSelected() {
        this.selectedRows = this.gridApi.getSelectedRows()
    }

    onGridReady({ api }: any) {
        this.gridApi = api
    }

    onRowClickedSidepanel() {
        this.showSidepanel = true
    }

    showConceptsmodalBasicForm(title: string) {
        this.actionTitle = title
        this.conceptsModalBasicForm.show()
    }

    // TODO: Mejorar esto en Front
    async deleteAccountingConcept() {
        await this.$_showConfirmationModal(`${this.$t('configuration.grid.deleteConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$t('configuration.grid.deleteQuestion')}`, this.$t('configuration.actions.delete').toString())
    }
}
